import EventCache from './EventCache';
import Constants from 'components/show_drawing/Constants.jsx';

// List of event types that should be cached for unmounted options
const CACHEABLE_EVENTS = [
  Constants.drawing_option_recommended_value_changed,
  Constants.drawing_option_visible_updated,
  Constants.drawing_option_set_value,
  Constants.drawing_option_recommended_value_changed_add_ons,
  Constants.drawing_option_highlight,
  // Note: drawing_redraw_completed and drawing_addon_redraw_completed are broadcast events
  // that don't have specific id+name, so they won't be cached
];

// Service to intercept and cache events for unmounted options
class EventCacheService {
  constructor() {
    this.initialized = false;
  }

  // Initialize the service - should be called once when the app starts
  initialize() {
    if (this.initialized) {
      return;
    }

    // Add listeners for all cacheable events
    CACHEABLE_EVENTS.forEach(eventType => {
      document.addEventListener(eventType, (e) => {
        this.handleEvent(eventType, e.detail);
      });
    });

    this.initialized = true;
    console.log('[EventCacheService] Initialized - listening for option events');
  }

  // Handle an event - cache it if the option is unmounted
  handleEvent(eventType, detail) {
    const wasCached = EventCache.maybeCache(eventType, detail);

    if (wasCached && false) {
      console.log('[EventCacheService] Cached event:', {
        eventType,
        id: detail.id,
        name: detail.name,
        value: detail.value
      });
    }
  }

  // Expose EventCache methods for components to use
  register(id, name) {
    return EventCache.register(id, name);
  }

  unregister(id, name) {
    return EventCache.unregister(id, name);
  }

  getAndClear(id, name) {
    return EventCache.getAndClear(id, name);
  }

  // Debug helpers
  debug() {
    EventCache.debug();
  }
}

// Export singleton instance
export default new EventCacheService();
